import React from 'react';
import PropTypes from 'prop-types';

function DialogContent({ children, classes, className, component: Component = 'div', ...other }) {
  return (
    <Component className={className} {...other}>
      {children}
    </Component>
  );
}

DialogContent.propTypes = {
  component: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DialogContent;
